(() => {
  let syncFrame;

  const syncFallbackFilters = () => {
    const params = new URLSearchParams(window.location.search);

    document
      .querySelectorAll('[data-gift-filter-fallback] .filter-group__checkbox')
      .forEach((input) => {
        const shouldBeChecked = params.getAll(input.name).includes(input.value);
        if (input.checked !== shouldBeChecked) input.checked = shouldBeChecked;
      });
  };

  const scheduleSync = () => {
    window.cancelAnimationFrame(syncFrame);
    syncFrame = window.requestAnimationFrame(syncFallbackFilters);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncFallbackFilters);
  } else {
    syncFallbackFilters();
  }

  window.addEventListener('popstate', scheduleSync);
  document.addEventListener('shopify:section:load', scheduleSync);

  new MutationObserver((mutations) => {
    if (mutations.some((mutation) => mutation.addedNodes.length > 0)) scheduleSync();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
